module.exports = __webpack_public_path__ + "img/cart-footer-data.64c46c73.png";